import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import AddressCommon from '@/app-core/mixins/maps/addressCommon'

export default {
  name      : 'AccountSelectAddressDialog',
  components: {},
  directives: {},
  mixins    : [DialogVisible, AddressCommon],
  props     : {},
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onSelectAddressClick(address) {
      this.setAddress(address)
    },

    async setAddress(address) {
      const result = await this.isPlaceInsideDeliveryAreas(this.addressToPlaceObject(address))

      if (result) {
        this.isVisible = false
        this.$emit('address:selected', address)
      } else {
        this.notifyUserOutOfBoundsAddress()
      }
    }
  }
}
